import React from 'react';

import { TTimesheetRejection } from './useTimesheetDetails';
import { formatDisplayDateTime } from '../../../utils';

type TimesheetRejectionsProps = {
    statusDisplay?: string;
    rejections: TTimesheetRejection[];
};

const formatDateTime = (dateString?: string) => {
    if (!dateString) return '';
    return formatDisplayDateTime(dateString, '');
};

export const TimesheetRejections: React.FC<TimesheetRejectionsProps> = ({
    statusDisplay,
    rejections,
}) => (
    <div className="timesheet-rejections">
        <div className="timesheet-rejections__title">
            {statusDisplay || 'Rejections'}
        </div>
        {rejections.length === 0 ? (
            <div className="timesheet-rejections__item">No rejection messages</div>
        ) : (
            rejections.map(rej => (
                <div
                    key={rej.created}
                    className="timesheet-rejections__item timesheet-rejections__item--stacked"
                >
                    <div className="timesheet-rejections__meta">
                        {formatDateTime(rej.created)}
                    </div>
                    <div className="timesheet-rejections__reason">
                        {rej.reason}
                    </div>
                </div>
            ))
        )}
    </div>
);

TimesheetRejections.displayName = 'TimesheetRejections';
